module.exports = __webpack_public_path__ + "img/isa6.76bea119.png";